import { useQuery, useMutation } from "../../api/hooks";
import useAuth from "../../context/useAuth";
import appToast from "../../components/appToast";
import { clearTokens } from "../../utils/cookies";

export const useSendOtpMutation = () =>
  useMutation("api/auth/check", { silent: true });

export const useVerifyMutation = () =>
  useMutation("api/auth/login", { silent: true });

export const useLogoutMutation = () => {
  const { clearUser } = useAuth();

  return useMutation("api/auth/logoff", {
    onSuccess: () => {
      appToast.success("Logged out successfully");
      // Clear tokens securely
      clearTokens();
      clearUser();
    },
  });
};

export const useUserInfoQuery = (_, options = {}) =>
  useQuery("api/auth/getuserinfo", { skip: options.skip ?? false });
